__turbopack_context__.v({
  "accordion": "_6Qxgta_accordion",
  "footer": "_6Qxgta_footer",
  "header": "_6Qxgta_header",
  "mastercard": "_6Qxgta_mastercard",
  "mastercardLogo": "_6Qxgta_mastercardLogo",
  "sasHeaderCompanyName": "_6Qxgta_sasHeaderCompanyName",
  "sasInnerEurobonusmc": "_6Qxgta_sasInnerEurobonusmc",
  "saseurobonusmc": "_6Qxgta_saseurobonusmc",
  "sebLogo": "_6Qxgta_sebLogo",
  "useHeader": "_6Qxgta_useHeader",
});
